import $ from 'jquery';
import './main.js';